import Swal from "sweetalert2";
import { ApiCalls } from "../../api/allapiCall";
import {
    store,
    appName,
    trackActivity,
    enabledFeatures,
    SUPER_ADMIN,
    getUniquePracticeIds,
    getRegionalOptions,
    CANADA,
    swalMessage,
    generateMachineName,
    allFeatures,
    showErrorMessage,
    error_image,
    confirmBtn,
} from "../../utils/index.js";
import { eventName, eventType } from "../../tracking/Tracking";
import {
    getRegionalData,
    initRegionalStates,
    negativeNumberFormatOptions,
} from "../Settings/SettingsHelpers.js";
import Error_image from "../../assets/images/icons/Error_image.png";
import { initConstructTableCols } from "../../state/initialStates.js";

export const initialState = {
    username: store.get("sikka-username") || "",
    password: "",
    publicIP: "",
};

function updateInitConstructTableCols(enabledFeatures, country, speciality) {
    if (speciality === "Dental") {
        if (country === "Canada") {
            return {
                patientName: true,
                insurance: enabledFeatures ? enabledFeatures.Insurance : true,
                provider: enabledFeatures ? enabledFeatures.Provider : true,
                time: enabledFeatures ? enabledFeatures.TimeProcedures : true,
                healthRisk: enabledFeatures ? enabledFeatures.Leca : true,
                economicWellBeing: enabledFeatures
                    ? enabledFeatures.PEWS
                    : true,
                medicalCondition: enabledFeatures
                    ? enabledFeatures.MedicalCondition
                    : true,
                arBalance: enabledFeatures ? enabledFeatures.ARBalance : true,
                treatmentPlan: enabledFeatures
                    ? enabledFeatures.TreatmentPlans
                    : true,
            };
        } else {
            return {
                patientName: true,
                insurance: enabledFeatures ? enabledFeatures.Insurance : true,
                // eligibility: enabledFeatures
                //     ? enabledFeatures.Eligibility
                //     : true,
                provider: enabledFeatures ? enabledFeatures.Provider : true,
                time: enabledFeatures ? enabledFeatures.TimeProcedures : true,
                healthRisk: enabledFeatures ? enabledFeatures.Leca : true,
                economicWellBeing: enabledFeatures
                    ? enabledFeatures.PEWS
                    : true,
                medicalCondition: enabledFeatures
                    ? enabledFeatures.MedicalCondition
                    : true,
                arBalance: enabledFeatures ? enabledFeatures.ARBalance : true,
                treatmentPlan: enabledFeatures
                    ? enabledFeatures.TreatmentPlans
                    : true,
            };
        }
    } else if (speciality === "Veterinary") {
        return {
            provider: enabledFeatures ? enabledFeatures.Provider : true,
            time: enabledFeatures ? enabledFeatures.TimeProcedures : true,
            medicalCondition: enabledFeatures
                ? enabledFeatures.MedicalCondition
                : true,
            arBalance: enabledFeatures ? enabledFeatures.ARBalance : true,
            treatmentPlan: enabledFeatures
                ? enabledFeatures.TreatmentPlans
                : true,
            patient: true,
            owner: true,
            type: true,
            lastWeight: true,
            compliance: true,
            petWellBeing: enabledFeatures ? enabledFeatures.PEWS : true,
        };
    }
}

function countCols(obj) {
    const numOfCols = Object.values(obj).filter(
        (value) => value === true
    ).length;
    return numOfCols;
}

export const setRegionalSettings = async (regionalData, res, combinedStore) => {
    let rawDataToStore = initRegionalStates;
    // If there is no data in the DB, store default initRegionalStates
    if (regionalData.length === 0) {
        if (res.country === CANADA) {
            rawDataToStore = { ...initRegionalStates, Country: "en-CA" };
        }
    } else {
        rawDataToStore = getRegionalData(regionalData);
    }
    store.set("session", "rawRegionalSettings", rawDataToStore);

    const regionalOptions = await getRegionalOptions(
        res.masterCustomerID,
        rawDataToStore.Country
    );

    // eslint-disable-next-line
    const [positiveCurrency, negativeCurrency, dateTime] = regionalOptions;

    let CurrencyPositivePattern = "$n";
    const pos =
        positiveCurrency[parseInt(rawDataToStore.CurrencyPositivePattern)];
    if (pos) CurrencyPositivePattern = pos.positiveCurrency;

    let CurrencyNegativePattern = "($n)";
    const neg =
        negativeCurrency[parseInt(rawDataToStore.CurrencyNegativePattern)];
    if (neg) CurrencyNegativePattern = neg.negativeCurrency;

    let NumberNegativePattern = "(n)";
    const negNum = negativeNumberFormatOptions.find(
        (n) => n.value === rawDataToStore.NumberNegativePattern
    );
    if (negNum) NumberNegativePattern = negNum.label;

    combinedStore("regionalSettings", {
        ...rawDataToStore,
        NumberNegativePattern,
        CurrencyPositivePattern,
        CurrencyNegativePattern,
        ShortDatePattern: rawDataToStore.ShortDatePattern.toUpperCase(),
    });
};

export const proceedLogin = async (
    combinedStore,
    res,
    setLoading,
    credentials,
    setCredentials,
    rememberUsername,
    navigate,
    isSwitchingAcc
) => {
    const appEndPoint =
        appName === "Self-Driving Practice" ? "SDP" : "SikkaPrime";

    try {
        // GET USER ACCESS PRACTICE IDS and Regional Data
        const token = res.apiToken.token;
        const apiCalls = [
            ApiCalls.authGetAPIWithTokenParam(
                "/UserAccount/UserAccessPracticeID",
                {
                    masterId: res.masterCustomerID,
                    userId: res.userID,
                    appName,
                },
                token
            ),
            ApiCalls.authGetAPIWithTokenParam(
                "/Setting/RegionalSettingData",
                {
                    masterId: res.masterCustomerID,
                    userId: res.userID,
                },
                token
            ),
            ApiCalls.authGetAPIWithTokenParam(
                `/UserAccount/Check${appEndPoint}License`,
                {
                    masterId: res.masterCustomerID,
                },
                token
            ),
        ];

        if (!store.get("sikkaAdmin")) {
            apiCalls.push(
                ApiCalls.authGetAPIWithTokenParam(
                    "/UserAccount/FirstTimeLogInDetails",
                    {
                        masterId: res.masterCustomerID,
                        userId: res.userID,
                    },
                    token
                )
            );
        }

        const response = await Promise.all(apiCalls);
        const [
            userAccessPracticeId,
            regionalData,
            license,
            firstTimeLogInDetails,
        ] = response;
        let activeItem;
        let constructTableColumns = initConstructTableCols;
        const userFeatures = { ...enabledFeatures };

        ///////////////////////////////////////////////////////////////////////
        // GET PRACTICES LIST
        // If the userAccessPracticeId return empty array, then pass "" in practiceId field
        let practiceId = "";
        if (userAccessPracticeId.length > 0) {
            practiceId = userAccessPracticeId.reduce(
                (prev, curr) => prev + curr.practiceId + ",",
                ""
            );
        }

        if (res.user_Type != SUPER_ADMIN) {
            const userAccessData = await ApiCalls.authGetAPIWithTokenParam(
                "/UserAccount/UserAccessData",
                {
                    masterId: res.masterCustomerID,
                    userId: res.userID,
                },
                token
            );

            if (
                userAccessData.practices &&
                userAccessData.practices.length > 0
            ) {
                if (
                    userAccessData.features.practices &&
                    userAccessData.features.practices.length > 0
                ) {
                    [...userAccessData.features.practices].forEach((item) => {
                        if (item.status === "Show") {
                            userFeatures[item.feature] = true;
                        } else if (item.status === "Hide") {
                            userFeatures[item.feature] = false;
                        }
                    });
                }
                activeItem = {
                    type: "solo",
                    name: userAccessData.practices[0].practiceName,
                    groupId: "",
                    items: [userAccessData.practices[0]],
                };
            } else if (
                userAccessData.groups &&
                userAccessData.groups.length > 0
            ) {
                if (
                    userAccessData.features.groups &&
                    userAccessData.features.groups.length > 0
                ) {
                    [...userAccessData.features.groups].forEach((item) => {
                        if (item.status === "Show") {
                            userFeatures[item.feature] = true;
                        } else if (item.status === "Hide") {
                            userFeatures[item.feature] = false;
                        }
                    });
                }
                activeItem = {
                    type: "group",
                    name: userAccessData.groups[0].groupName,
                    groupId: userAccessData.groups[0].groupId,
                    items: userAccessData.groups[0].practiceGroupItems,
                };
            } else {
                setLoading(false);
                swalMessage(
                    "error",
                    "",
                    "You do not have access to any Practice/Group. Please contact Super Admin."
                );
                if (setCredentials) setCredentials(initialState);
                return;
            }

            constructTableColumns = updateInitConstructTableCols(
                userFeatures,
                res.country,
                res.speciality
            );
            const uniquePracticeIdsArray = getUniquePracticeIds(
                userAccessData.practices,
                userAccessData.groups
            );
            practiceId = uniquePracticeIdsArray.join(",");
        }

        let practiceList = await ApiCalls.authGetAPIWithTokenParam(
            "/UserAccount/PracticeData",
            {
                masterId: res.masterCustomerID,
                practiceId,
            },
            token
        );

        if (practiceList.length === 0) {
            showErrorMessage(
                "You are not currently assigned to any practice. Please reach out to us or your supervisor for assistance."
            );
            return;
        }

        practiceList = practiceList.map((p) => ({
            ...p,
            custID: parseInt(p.custID),
        }));

        const data = {
            masterId: res.masterCustomerID,
            custId: practiceList[0]?.custID || 1,
            apiToken: res.apiToken.token,
            userEmail: res.userEmail,
            userId: res.userID,
            ipAddress: store.get("ip")?.ip,
            machineName: generateMachineName(),
            domainName: res.speciality,
            dateFormat: res.country === "Canada" ? "YYYY-MM-DD" : "MM-DD-YYYY",
            country: res.country,
            user_Type: res.user_Type,
            userFullName: res.userFName + " " + res.userLName,
        };

        ///////////////////////////////////////////////////////////////////////////////
        // check if the user is subscriber or trial user or unAuthorized user
        let trialStartDate;
        let typeOfSubscriber = "";
        if (license.length === 0) {
            // first time user, account not activated yet
            setLoading(false);
            Swal.fire({
                imageUrl: error_image,
                imageHeight: 66,
                text: "Your account is not activated. Please register by clicking on the Register button below.",
                confirmButtonText: "Close",
                customClass: {
                    confirmButton: confirmBtn,
                },
                footer: `<a style="color: #681c9a" href="https://sikka.ai/SikkaPrime" target="_blank" rel="noopener noreferrer">Register</a>`,
            });
            return;
        } else {
            // user account already activated
            const availableService = license[0].availableService;
            if (
                availableService === "Self-Driving Practice" ||
                availableService === "Self-Driving Practice Premium" ||
                availableService === "Sikka Prime" ||
                availableService === "Sikka Prime Premium"
            ) {
                typeOfSubscriber =
                    availableService === "Self-Driving Practice Premium" ||
                    availableService === "Sikka Prime Premium"
                        ? "Premium"
                        : "";
            } else if (
                (availableService === "Self-Driving Practice Trial" ||
                    availableService === "Sikka Prime Trial") &&
                license[0].serviceStartDate
            ) {
                // If the user is a trial user, check if the status is Active or Inactive.
                // If status is Inactive, it means the trial period ended. Show Message to customer
                if (license[0].serviceStatus === "InActive") {
                    setLoading(false);
                    Swal.fire({
                        title: "Trial Period Expired",
                        imageUrl: Error_image,
                        imageHeight: 66,
                        text: "Buy our product for unlimited access to full features",
                        footer: 'Purchase Sikka Prime at <a style="margin-left: 5px" target="_blank" rel="noopener noreferrer" href="https://sikka.ai/SikkaPrime">https://sikka.ai/SikkaPrime</a>',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: "primary-btn",
                        },
                    });
                    return;
                }

                // Track trial user login
                trackActivity(
                    eventType.LOGIN,
                    eventName.TRIAL_LOGIN,
                    "Login page >> login as trial user"
                );
                trialStartDate = license[0].serviceStartDate;
            }
        }

        ///////////////
        if (res.user_Type != SUPER_ADMIN) {
            combinedStore("constructTableColumns", constructTableColumns);
            combinedStore("userFeatures", userFeatures);
            combinedStore("numOfCols", countCols(constructTableColumns));
        } else {
            combinedStore("constructTableColumns", initConstructTableCols);
            combinedStore("userFeatures", allFeatures);
            combinedStore("numOfCols", countCols(initConstructTableCols));
        }
        combinedStore("userInfo", data);
        combinedStore("practiceList", practiceList);
        if (res.user_Type === SUPER_ADMIN) {
            const firstPracticeInList = {
                ...practiceList[0],
                practiceId: practiceList[0]["practiceID"],
                custId: practiceList[0]["custID"],
            };
            delete firstPracticeInList.practiceID;
            delete firstPracticeInList.custID;
            combinedStore("activeItem", {
                type: "solo",
                name: firstPracticeInList.practiceName,
                groupId: "",
                items: [firstPracticeInList],
            });
        } else {
            combinedStore("activeItem", activeItem);
        }

        if (credentials) {
            if (rememberUsername) {
                store.set("local", "sikka-username", credentials.username);
            } else {
                localStorage.removeItem("sikka-username");
            }
        }

        if (trialStartDate) {
            combinedStore("trialStartDate", trialStartDate);
        }
        setRegionalSettings(regionalData, res, combinedStore);
        if (
            firstTimeLogInDetails &&
            firstTimeLogInDetails[0]?.isSuccess &&
            firstTimeLogInDetails[0]?.isFirstTimeLoggedIn
        ) {
            combinedStore("firstTimeLoggedIn", true);
            store.set("session", "firstTimeLoggedIn_showVideo", true);
        }

        // Track subscriber login
        trackActivity(
            eventType.LOGIN,
            eventName.SUBSCRIBER_LOGIN,
            "Login page >> login as " + typeOfSubscriber
        );

        if (isSwitchingAcc) {
            sessionStorage.removeItem("pageLoaded");
            sessionStorage.removeItem("constructTableDate");
            location.reload();
        } else {
            navigate("/");
        }
    } catch (err) {
        console.log(err);
    }
};

export const initTableState = {
    sort: [
        {
            field: "masterCustomerID",
            dir: "asc",
        },
    ],
    filter: null,
};

export const initData = {
    data: [],
    total: 0,
};

export const SelectCustomerCell = ({
    dataItem,
    setSelectedRow,
    selectedRow,
}) => {
    return (
        <td>
            <input
                type="checkbox"
                style={{ marginTop: 4, width: 18, height: 18 }}
                checked={
                    dataItem["masterCustomerID"] ==
                        selectedRow?.masterCustomerID &&
                    dataItem["userID"] == selectedRow?.userID &&
                    dataItem["userFName"] == selectedRow?.userFName &&
                    dataItem["userLName"] == selectedRow?.userLName
                }
                onChange={() => setSelectedRow(dataItem)}
                onClick={(e) => e.stopPropagation()}
            />
        </td>
    );
};
